module.exports = __webpack_public_path__ + "static/img/home_bottom.6357c747.png";